import React, { useEffect } from "react";
import { ProductKinds, SaleStep } from "../../../store/stepSaleConfig/stepSaleConfigReducer";
import useTickets from "../../LimitedTicket/hooks/useTickets";
import EASkeletonLoader from "../../shared/EASkeletonLoader";
import LimitedTicketBlock from "../../LimitedTicket/LimitedTicketBlock";
import { replaceVariablesInString } from "./replaceVariablesInString";

interface IProps {
  saleStep: SaleStep;
}

const ShapeColorAssortGroupModule: React.FC<IProps> = ({ saleStep }) => {
  const {
    shapeGroup,
    colorGroup,
    assortGroup,
    requestGetAssortGroups,
    requestGetColorGroups,
    requestGetShapeGroup,
    loading,
  } = useTickets();

  useEffect(() => {
    switch (saleStep.kind) {
      case ProductKinds.Shape:
        requestGetShapeGroup(saleStep.shapeIds);
        break;
      case ProductKinds.Color:
        requestGetColorGroups(saleStep.colorIds);
        break;
      case ProductKinds.AssortGroup:
        requestGetAssortGroups(saleStep.assortGroupIds);
        break;
      default:
        return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const highlightedFeatures = [
    saleStep.highlightedFeature1,
    saleStep.highlightedFeature2,
    saleStep.highlightedFeature3,
  ].filter(Boolean);


  if (loading) return <EASkeletonLoader height="200px" />;

  if (saleStep.kind === ProductKinds.Shape && shapeGroup.length > 0)
    return (
      <div className="module-list">
        {shapeGroup.map((item, index) => (
          <LimitedTicketBlock
            saleStep={saleStep}
            item={item}
            sortType="shapeGroup"
            key={index}
            highlightBanner={saleStep.highlightBanner}
            bannerLabel={replaceVariablesInString(saleStep.bannerLabel, item)}
            customMainPrice={saleStep.mainPrice}
            crossedPrice={saleStep.crossedPrice}
            additionalPriceInfo={saleStep.priceLabel}
            highlightedFeatures={highlightedFeatures}
            passSaleVariant={saleStep.passSaleVariant}
            buttonCustomTitle={saleStep.buttonCustomTitle}
          />
        ))}
      </div>
    );

  if (saleStep.kind === ProductKinds.Color && colorGroup.length > 0)
    return (
      <div className="module-list">
        {colorGroup.map((item, index) => (
          <LimitedTicketBlock
            saleStep={saleStep}
            item={item}
            sortType="colorGroup"
            key={index}
            highlightBanner={saleStep.highlightBanner}
            bannerLabel={replaceVariablesInString(saleStep.bannerLabel, item)}
            customMainPrice={saleStep.mainPrice}
            crossedPrice={saleStep.crossedPrice}
            additionalPriceInfo={saleStep.priceLabel}
            highlightedFeatures={highlightedFeatures}
            passSaleVariant={saleStep.passSaleVariant}
            buttonCustomTitle={saleStep.buttonCustomTitle}
          />
        ))}
      </div>
    );

  if (saleStep.kind === ProductKinds.AssortGroup && assortGroup.length > 0)
    return (
      <div className="module-list">
        {assortGroup.map((item, index) => (
          <LimitedTicketBlock
            saleStep={saleStep}
            item={item}
            sortType="assortGroup"
            key={index}
            highlightBanner={saleStep.highlightBanner}
            bannerLabel={replaceVariablesInString(saleStep.bannerLabel, item)}
            customMainPrice={saleStep.mainPrice}
            crossedPrice={saleStep.crossedPrice}
            additionalPriceInfo={saleStep.priceLabel}
            highlightedFeatures={highlightedFeatures}
            passSaleVariant={saleStep.passSaleVariant}
            buttonCustomTitle={saleStep.buttonCustomTitle}
          />
        ))}
      </div>
    );

  return <></>;
};

export default ShapeColorAssortGroupModule;
